//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {UserMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import Breadcrumbs from "~/components/page/PageBreadcrumbs.vue";
import CurrentCountry from "~/components/page-service/CurrentCountry.vue";
import CountriesSelect from "~/components/page-service/CountriesSelect.vue";

export default {
  name: "countriesSubPage",

  async asyncData({route, $api, $cookies}) {
    const slug = route?.params?.pathMatch || '';

    const currentCountry = await $api.agent.transport
      .get(`/country/get-by-slug/${slug}`)
      .then(res => {
        return res.data;
      })
      .catch((err) => {
      });

    let currentNumbers = [];
    let currentService = null;
    if (currentCountry?.external_id) {
      currentNumbers = await $api.agent.transport
        .get(`service/get-prices/${currentCountry?.external_id}?user=guest`)
        .then((res) => {
          return res.data || []
        })
        .catch(() => {
          return []
        });
      currentNumbers = currentNumbers.map((item) => {
        return {
          ...item,
          nameLowerCase: String(item?.name || '').toLowerCase()
        }
      })

      const selectedServiceIdExternal = $cookies.get('selectedServiceIdExternal') || null;
      currentService = currentNumbers.find((t) => t.service_external_id === selectedServiceIdExternal);
      if (!currentService) {
        currentService = currentNumbers[0];
      }
    }

    return {
      currentCountry,

      currentNumbers,
      currentService,
      isLoadPrices: Boolean(currentNumbers.length <= 0)
    }
  },

  head: function () {
    const title = this.currentCountry?.seo_title || this.currentCountry?.name;

    const head = {
      title: title,
      meta: [],
    }
    if (title) {
      head.meta.push({
        name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
      });
    }

    const description = this.currentCountry?.seo_description || "";
    if (description) {
      head.meta.push({hid: 'metadescription', name: 'description', content: description});
      head.meta.push({
        name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
      });
    }

    return head
  },

  mixins: [UserMixin],

  data: function () {
    return {
      currentNumbers: [],
      currentService: null,
      isLoading: false,
      isLoadPrices: false,
      isDisabledBuy: false,
    }
  },


  async created() {
    if (!this.currentCountry) {
      this.$nuxt.error({
        statusCode: 404,
        message: this.$t('errorPage.pageNotFound')
      })
      return;
    }

    const authToken = this.$cookies.get('authToken');
    if (authToken) {
      await this.$store.dispatch('user/getUser');
    }

    await this.getNumberFromCurrentCountry()

    // Определение активного сервиса из куки
    const selectedServiceIdExternal = this.$cookies.get('selectedServiceIdExternal') || null;
    let currentService = this.currentNumbers.find((t) => t.service_external_id === selectedServiceIdExternal);
    if (!currentService) {
      currentService = this.currentNumbers[0];
    }
    this.currentService = currentService;
  },

  components: {
    Breadcrumbs,
    CurrentCountry,
    CountriesSelect
  },

  computed: {
    breadcrumbs: function () {
      return [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: this.currentCountry?.name || ''}
      ]
    },

    countryIcon: function () {
      return this.currentCountry?.icon_id
    },
    countryName: function () {
      return this.currentCountry?.name
    },

    isCountryRussia: function () {
      const isSlug = Boolean(String(this.currentCountry?.slug) === String("russia"));
      const isExternalId = Boolean(String(this.currentCountry?.external_id) === String("0"));
      return Boolean(isSlug || isExternalId)
    },
    isServiceDisabled: function () {
      return !Boolean(this.currentService?.button_status)
    },


    cmsTitle: function () {
      return this.currentCountry?.seo_h1 || this.currentCountry?.name || ""
    },
    cmsMessage: function () {
      const description = this.currentCountry?.description || '';
      if (!description) {
        return description
      }

      const isRussianVersionSite = Boolean(String(this.$nuxt?.context?.env?.baseApiUrl || '').includes('9grizzlysms.com'));
      if (!!isRussianVersionSite) {
        return String(description || '')
          .replace(new RegExp('https://grizzlysms.com/ru', 'g'), 'https://9grizzlysms.com')
          .replace(new RegExp('https://grizzlysms.com', 'g'), 'https://9grizzlysms.com')
      }

      return String(description || '')
        .replace(new RegExp('https://9grizzlysms.com', 'g'), 'https://grizzlysms.com/ru')
    },

    // ----------------------------
    isUserAuth() {
      return this.$store.getters['user/isLoggedIn'];
    },
    user() {
      return this.$store.getters['user/user'] || null;
    }
  },

  methods: {
    async onBuyNumber(props = {}) {
      this.isDisabledBuy = true;
      const {customCountryId = null, serviceId = ''} = props;
      const paymentTest = this.$cookies.get("payment-test");

      if (!this.user && paymentTest) {
        this.isDisabledBuy = false;
        await this.$router.push(this.localePath(`/profile/pay?service=${serviceId || this.currentService?.service_external_id}&country=${customCountryId || this?.currentCountry?.external_id}`));
        return;
      }
      if (!this.isUserAuth && paymentTest) {
        this.isDisabledBuy = false;
        await this.$router.push(this.localePath("/registration?goback=1"));
        return null;
      }


      // Проверка баланса пользователя
      const balance = await this.$api.agent.transport.get("sms-users/balance")
        .then((res) => {
          return res.data
        }).catch(() => {
          return 0
        });

      if (paymentTest && balance < +this.currentService.price) {
        this.isDisabledBuy = false;
        await this.$router.push(this.localePath(`/profile/pay?service=${serviceId || this.currentService?.service_external_id}&country=${customCountryId || this?.currentCountry?.external_id}`));
        return;
      }
      if (!paymentTest && balance < +this.currentService.price) {
        this.isDisabledBuy = false;
        await this.$router.push(this.localePath("/profile/pay"));
        return
      }

      this.isLoading = true;
      let countryId = customCountryId || this?.currentCountry?.external_id;
      let serviceIdCust = serviceId || this.currentService?.service_external_id;

      const newNumber = await this.$api.agent.transport
        .get(`sms-users/get-number/${countryId}/${serviceIdCust}`)
        .catch((err) => {
          let error = JSON.parse(err?.request?.response);
          this.$toast.error(error.message || "Error");
          this.isLoading = false;
        });

      if (!newNumber) {
        this.isDisabledBuy = false;
        this.isLoading = false;
        return null;
      }

      if (this.$route.path !== "/profile") {
        await this.$router.push(this.localePath("/profile"));
      }

      // numberType === 'country' ?
      //   this.yandexGoalCheck('buy_service-country_success') :
      //   this.yandexGoalCheck('buy_service-main_success');
      //
      //
      // this.yandexSendUserID({
      //     userId: this?.user?.id,
      // })

      this.isDisabledBuy = false;
      this.isLoading = false;
      this.$store.commit("active-numbers/updateIndex");
    },


    async getNumberFromCurrentCountry() {
      let user = this?.user?.id ? this?.user?.id : 'guest';
      if (!this?.user?.dynamicFields?.custom_price) {
        user = 'guest';
      }
      if (user === "guest") {
        return
      }

      let currentNumbers = await this.$api.agent.transport
        .get(`service/get-prices/${this.currentCountry.external_id}?user=${user}`)
        .then((res) => {
          return res.data;
        })
        .catch(() => {
          return []
        });
      currentNumbers = currentNumbers.map((item) => {
        return {
          ...item,
          nameLowerCase: String(item?.name || '').toLowerCase()
        }
      })
      this.currentNumbers = currentNumbers;
      this.isLoadPrices = false;
    },

    changeCurrentService: function (service) {
      this.currentService = service;
    },
  },
}
